// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sessionPageLeftContainer {
  width: 100%;
  /* padding: 16px 0px 16px 14px; */
  padding: 0px 0px 0px 0px;
  height: 99vh;
}

.sessionPageOuterImage {
  height: 100%;
}

.sessionPageImageContainer {
  position: relative;
  border-radius: 16px;
  height: 100%;
}

.sessionPageInnerImage {
  height: 400px;
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.sessionPageRightContainer {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  /* background-color: red; */
  flex-direction: column;
}

.sessionPageHeadingText {
  font-size: 1.5rem;
  font-weight: 700;
}

.sessionPageLabelText {
  color: var(--surface-g4);
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPageV2/SessionPageV2.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iCAAiC;EACjC,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".sessionPageLeftContainer {\n  width: 100%;\n  /* padding: 16px 0px 16px 14px; */\n  padding: 0px 0px 0px 0px;\n  height: 99vh;\n}\n\n.sessionPageOuterImage {\n  height: 100%;\n}\n\n.sessionPageImageContainer {\n  position: relative;\n  border-radius: 16px;\n  height: 100%;\n}\n\n.sessionPageInnerImage {\n  height: 400px;\n  width: 400px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.sessionPageRightContainer {\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  /* background-color: red; */\n  flex-direction: column;\n}\n\n.sessionPageHeadingText {\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.sessionPageLabelText {\n  color: var(--surface-g4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
